<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.code }}</strong>
                </CCardHeader>
                <CCardBody>
                    <AdsPlaceTabLinks />
                    <AdsPlaceUpsertForm
                        class="mt-4 ml-2 ml-2"
                        :entity.sync="entity"
                        @update="fetch"
                        @success="$router.push(`/ads-places`)"
                        @deleted="$router.push(`/ads-places`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import AdsPlaceTabLinks from '@/components/ads-places/AdsPlaceTabLinks';
    import AdsPlaceUpsertForm from '@/components/ads-places/AdsPlaceUpsertForm';

    export default {
        name: 'AdsPlaceEdit',

        components: {
            AdsPlaceTabLinks,
            AdsPlaceUpsertForm,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/ads-places/${id}`)).data;
            },
        },
    };
</script>
